import { InboxChannel } from "../models/messagesInbox/IInboxConversation";

/**
 * File types each channel accepts on a reply. eBay messages only take photos (JPEG or PNG).
 * TODO(stuart): confirm what PartPro accepts - assumed the same as eBay for now.
 */
export const ALLOWED_ATTACHMENT_TYPES: Record<InboxChannel, { mimeTypes: string[]; label: string }> = {
  ebay: { mimeTypes: ["image/jpeg", "image/png"], label: "JPEG or PNG photos" },
  partpro: { mimeTypes: ["image/jpeg", "image/png"], label: "JPEG or PNG photos" },
};

/** For the file picker's `accept`, so only allowed files can be chosen. */
export function attachmentAccept(channel: InboxChannel) {
  return ALLOWED_ATTACHMENT_TYPES[channel].mimeTypes.join(",");
}

/** Splits picked files into ones the channel accepts and the names of ones it doesn't. */
export function checkAttachments(files: { name: string; type: string }[], channel: InboxChannel) {
  const allowed = ALLOWED_ATTACHMENT_TYPES[channel].mimeTypes;
  return {
    accepted: files.filter((f) => allowed.includes(f.type)),
    rejected: files.filter((f) => !allowed.includes(f.type)).map((f) => f.name),
  };
}
